import { TFunction } from "i18next"
import { frontendCurrency } from "utils/formatCurrency"

export const DETALLES_TOTAL_DOCUMENTOS_COLUMNS = (t: TFunction) => {
  const columns = [
    {
      key: "text",
      header: `${t("validaciones.documentos.detail.item")}`,
      field: "text",
    },
    {
      key: "number",
      header: `${t("validaciones.documentos.detail.total")}`,
      field: "number",
      body: ({ number }: { number?: number }) =>
        number !== undefined ? frontendCurrency(number) : "-",
      bodyClassName: "!tw-text-end",
      alignCol: "right",
    },
  ]
  return columns
}
